import script from "./BotsTiles.vue?vue&type=script&setup=true&lang=js"
export * from "./BotsTiles.vue?vue&type=script&setup=true&lang=js"

import "./BotsTiles.vue?vue&type=style&index=0&id=00153146&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00153146"]])

export default __exports__